import SEARCH_RESULT_LAYOUT from "../../components/articles/shared/article-badges/SearchResultLayout";
import { SessionStore } from "../../uidispatcherapi/SessionStore";
import CustomerStore from "../CustomerStore";
import CountryUtil from "../../uidispatcherapi/CountryUtil";

const FSD_FILTER_SETTING = "fsdFilter";
const SEARCH_RESULT_LAYOUT_SETTING = "searchResultLayout";
import { Store } from "../../utils/Store";
import { GdprStorage } from "../../uidispatcherapi/GdprStorage";
import { SearchResultLayout } from "../../components/articles/shared/article-badges/SearchResultLayout";

class CustomerSettingsStoreClass extends Store {
    localstorage!: any;

    constructor() {
        super();
        this.init();
    }

    // necessary for testing
    init() {
        this.localstorage = GdprStorage.localStorage;
    }

    isFsdFilterApplicable() {
        return (
            (SessionStore.isMarioCountry() || CountryUtil.getOptionalConfig().showFSDFilter) &&
            CustomerStore.isCurrentCustomerFsdCustomerInSelectedStore()
        );
    }

    isFsdFilterActive() {
        if (!this.isFsdFilterApplicable()) {
            return false;
        }

        const filterDefaultSetting = !!CountryUtil.getOptionalConfig().defaultFilterOnlyFSD;
        const rawResult = this.localstorage.get(FSD_FILTER_SETTING);
        if (!rawResult || !rawResult.actualResult) {
            return filterDefaultSetting;
        }
        const result = JSON.parse(rawResult.actualResult);
        const customerId = SessionStore.getCustomerId();
        if (result === null || result.customer !== customerId || result.filter === undefined) {
            return filterDefaultSetting;
        }

        return result.filter === "true" || result.filter === true;
    }

    setFsdFilter(newState: boolean) {
        const data = {
            customer: SessionStore.getCustomerId(),
            filter: newState
        };
        this.localstorage.put(FSD_FILTER_SETTING, JSON.stringify(data), GdprStorage.NECESSARY);
        this.trigger();
    }

    getSearchResultLayout(): SearchResultLayout {
        const result = this.localstorage.read(SEARCH_RESULT_LAYOUT_SETTING);
        if (!result) {
            return SEARCH_RESULT_LAYOUT.LIST;
        }
        return result as any;
    }

    setSearchResultLayout(layoutSetting: SearchResultLayout) {
        this.localstorage.put(SEARCH_RESULT_LAYOUT_SETTING, layoutSetting, GdprStorage.NECESSARY);
    }
}

const CustomerSettingsStore = new CustomerSettingsStoreClass();
export default CustomerSettingsStore;
